<template>
  <div class="page-block">
    <header-bar v-if="isLoggedIn">運営会社</header-bar>
    <div class="page-block__heading page-block__heading--withbar">
      <h3 class="page-block__title">会社概要</h3>
    </div>
    <div class="page-block__inner">
      <div class="company-area">
        <table class="company-area__table">
          <tr>
            <th>サービス運営事業者</th>
            <td>{{ isMassenextLicenced ? '株式会社massenext' : '株式会社ローディアム' }}</td>
          </tr>
          <tr>
            <th>運営統括責任者</th>
            <td>{{ isMassenextLicenced ? '末松 央至' : '松坂 祐弥' }}</td>
          </tr>
          <tr>
            <th>所在地</th>
            <td
              v-if="isMassenextLicenced">
              〒107-0062 東京都港区南青山3-1-3 スプライン青山東急ビル4階
            </td>
            <td v-else>
              〒150-0043 東京都渋谷区道玄坂1-2-3 渋谷フクラス17F
            </td>
          </tr>
          <tr>
            <th>URL</th>
            <td>
              <a
                v-if="isMassenextLicenced"
                href="https://massenext.jp/"
                target="_blank">https://massenext.jp/
              </a>
              <a
                v-else
                href="https://www.roudiam.co.jp/"
                target="_blank">https://www.roudiam.co.jp/
              </a>
            </td>
          </tr>
          <tr>
            <th>適格請求書発行事業者登録番号</th>
            <td
              v-if="isMassenextLicenced">
              T5010401130365
            </td>
            <td v-else>
              T3011002032630
            </td>
          </tr>
        </table>
      </div>
      <div class="c-btn-wrap c-btn-wrap-faq">
        <router-link
          :to="{ name: 'index' }"
          class="c-btn c-btn--back c-btn-company">
          トップへ戻る
          <span class="c-btn__icon-arrow c-btn__icon-arrow--left"></span>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import HeaderBar from '../HeaderBar'

export default {
  name: 'Company',
  components: { HeaderBar },
  data() {
    return {
      isMassenextLicenced: false,
    }
  },
  computed: {
    ...mapGetters('auth', ['isLoggedIn']),
  },
  mounted() {
    this.isMassenextLicenced = !(this.isBtoC || this.appName === 'C-MAP')
  },
}
</script>

<style scoped>

</style>
